import React from "react"
import Testimonials from "../components/home/Testimonials"
import Works from "../components/home/Works"
import mockup from "../assets/images/mockup.png"
import logo from "../assets/images/Mock Creative.png"
import NavigateNextSharpIcon from '@material-ui/icons/NavigateNextSharp'
import { Link } from "react-router-dom"
import Layout from "../components/global/Layout"

function Home() {
  return (
    <Layout>
      <div className="home">
        <div className="row1">
          <div className="row1__section1 ">
            <p className="row1__section1__title ">Beyond Illegal Prescription</p>
            <p className="row1__section1__content">We help serve as a bridge between registered
                pharmacy stores and individuals to help get drugs at their convenient time.</p>
            <button className="row1__section1__button" ><Link to="/about">Learn More</Link></button>
            {/* <img src={googleplay} alt=""  /> */}
          </div>
          <div className="row__section2">
            <img className=" row1__section2__image" src={logo} alt="" />
          </div>

        </div>
        <Works />
        <Testimonials />
        <div className="news">
          <div className="news__section1">
            <p className="news__section1__title">
              Mobile App Coming Soon
            </p>
            <p className="news__section1__text">
              Be the first to know as soon as <br /> we release the Mobile Version
            </p>
            <div className="form">
              <input className="input" placeholder="email@example.com" type="text" />
              <NavigateNextSharpIcon fontSize="large" className="arrow" />
            </div>


          </div>
          <div className="news__section2">
            <img src={mockup} alt="" />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Home